<button type="button" class="agu-sidebar__mobile-toggle" (click)="OpenDrawer()" aria-label="Open navigation" [attr.aria-expanded]="drawerOpen">
    <i class="fa-solid fa-bars" aria-hidden="true"></i>
</button>
@if (drawerOpen) { <div class="agu-sidebar__backdrop" (click)="CloseDrawer()" aria-hidden="true"></div> }
<nav class="agu-sidebar" [attr.aria-label]="BrandName">
    <button type="button" class="agu-sidebar__collapse" [class.agu-sidebar__collapse--flipped]="collapsed" (click)="ToggleCollapsed()" [attr.aria-label]="collapsed ? 'Expand navigation' : 'Collapse navigation'" [attr.aria-pressed]="collapsed">
        <agu-icon Name="chevron-left" [Size]="16" />
    </button>
    <div class="agu-sidebar__brand">
        <!--
          The AGU mark (designer checklist 2026-10-24, "Update Logo to AGU"),
          painted by `--mj-brand-primary` through currentColor — see
          `.agu-sidebar__logo`. The Sep 1 mockup's three ascending bars
          (`home.html` `.logo .bars`) are superseded by that row.
        -->
        <!-- 24px in the 250px rail; 20px (52px wide) in the 78px collapsed rail, whose padding leaves 58px. A binding, because the svg lives in agu-logo's own template, out of this stylesheet's encapsulated reach. -->
        <agu-logo class="agu-sidebar__logo" [Height]="collapsed ? 20 : 24" />
        <span class="agu-sidebar__brand-name">{{ Wordmark }}</span>
        <button type="button" class="agu-sidebar__close" (click)="CloseDrawer()" aria-label="Close navigation"><i class="fa-solid fa-xmark" aria-hidden="true"></i></button>
    </div>
    @if (SearchPlaceholder) {
        <form class="agu-sidebar__search" (submit)="$event.preventDefault(); SubmitSearch(searchBox)" role="search">
            <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i>
            <input #searchBox type="search" [placeholder]="SearchPlaceholder" [attr.aria-label]="SearchPlaceholder" [value]="searchText" (input)="OnSearchInput($event)" name="q" />
        </form>
    }
    @if (Identity) {
        <div class="agu-sidebar__identity">
            <!-- The avatar is a link to the member's hub profile (`.prof-ring`, P/Member_Hub.html:1691-1693, 1744-1749). Absent when the host has no profile module. -->
            @if (Identity.ProfileLinkLabel) {
                <button type="button" class="agu-sidebar__prof-ring" aria-label="Open my hub profile" (click)="RequestProfile()">
                    <span class="agu-sidebar__avatar" aria-hidden="true"><span class="agu-sidebar__avatar-inner">{{ Identity.Initials }}</span></span>
                </button>
            } @else {
                <span class="agu-sidebar__avatar" aria-hidden="true"><span class="agu-sidebar__avatar-inner">{{ Identity.Initials }}</span></span>
            }
            <span class="agu-sidebar__name">{{ Identity.Name }}</span>
            @if (Identity.RoleLine) { <span class="agu-sidebar__role">{{ Identity.RoleLine }}</span> }
            @if (Identity.ProfileLinkLabel) { <button type="button" class="agu-sidebar__profile-link" (click)="RequestProfile()">{{ Identity.ProfileLinkLabel }}</button> }
        </div>
    }
    <ul class="agu-sidebar__nav" role="list">
        @for (module of VisibleModules; track module.Key) {
            <li [attr.data-tone]="ToneOf(module)">
                <button type="button" class="agu-sidebar__link" [class.agu-sidebar__link--active]="IsActive(module)" [attr.aria-current]="IsActive(module) ? 'page' : null" [attr.aria-label]="NavLabelOf(module)" (click)="SelectModule(module)" [attr.title]="collapsed ? NavLabelOf(module) : null">
                    @if (module.IconName) {
                        <agu-icon [Name]="module.IconName" [Size]="collapsed ? 20 : 19" [Solid]="IsActive(module)" />
                    } @else {
                        <i [class]="module.Icon" aria-hidden="true"></i>
                    }
                    <span class="agu-sidebar__label">{{ NavLabelOf(module) }}</span>
                </button>
            </li>
        }
    </ul>
    @if (Promo) {
        <aside class="agu-sidebar__promo">
            <span class="agu-sidebar__promo-eyebrow">{{ Promo.Eyebrow }}</span>
            <span class="agu-sidebar__promo-title">{{ Promo.Title }}</span>
            <span class="agu-sidebar__promo-text">{{ Promo.Text }}</span>
            <button type="button" class="agu-sidebar__promo-cta" (click)="RequestProfile()">{{ Promo.CtaLabel }} <agu-icon Name="arrow-right" [Size]="13" /></button>
        </aside>
    }
    <!-- The host's sidebar Featured placement (`agu-ad-slot ad`), after the Science Talent Network module (P/Member_Hub.html:1447). -->
    <div class="agu-sidebar__ad"><ng-content select="[ad]" /></div>
    <div class="agu-sidebar__account" #accountWrapper>
        <button type="button" class="agu-sidebar__link" (click)="ToggleAccount()" aria-label="Account menu" [attr.aria-expanded]="accountOpen" [attr.aria-controls]="AccountMenuId">
            <i class="fa-solid fa-circle-user" aria-hidden="true"></i><span class="agu-sidebar__label">Account</span>
        </button>
        @if (accountOpen) {
            <div [id]="AccountMenuId" class="agu-sidebar__menu" role="menu">
                @if (CanReturnToHost) { <button type="button" role="menuitem" aria-label="Back to Explorer" [attr.title]="collapsed ? 'Back to Explorer' : null" (click)="ReturnToHost()"><i class="fa-solid fa-arrow-left" aria-hidden="true"></i><span class="agu-sidebar__label">Back to Explorer</span></button> }
                <button type="button" role="menuitem" aria-label="Sign out" [attr.title]="collapsed ? 'Sign out' : null" (click)="SignOut()"><i class="fa-solid fa-right-from-bracket" aria-hidden="true"></i><span class="agu-sidebar__label">Sign out</span></button>
            </div>
        }
    </div>
</nav>
